import { DashboardGoalExport } from './dashboard-goal-export';

export class DashboardEmployeeExport {
    employeeName: string;
    rank: number;
    dailySalesPace: number;
    totalRankPoints: number;
    dashboardGoalExports: DashboardGoalExport[];
}
